import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useStore } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'SpotifyLogin',
  setup(__props) {

const store = useStore();
const loginWithSpotify = async () => {
  await store.dispatch('loginWithSpotify');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    onClick: loginWithSpotify,
    type: "button",
    class: "btn btn-lg btn-success"
  }, "Log in with spotify"))
}
}

})